import {Component, Inject, OnInit, ViewEncapsulation} from '@angular/core';
import {MAT_DIALOG_DATA} from '@angular/material/dialog';

@Component({
  selector: 'app-aristo-dialog',
  templateUrl: './aristo-dialog.component.html',
  styleUrls: ['./aristo-dialog.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class AristoDialogComponent implements OnInit {

  dialogText = '';

  constructor(@Inject(MAT_DIALOG_DATA) public data: any) { }

  ngOnInit(): void {
    this.dialogText = this.data.dialogText;
  }

}
